import { render, staticRenderFns } from "./bookContent.vue?vue&type=template&id=2eef73ae&scoped=true"
import script from "./bookContent.vue?vue&type=script&lang=js"
export * from "./bookContent.vue?vue&type=script&lang=js"
import style0 from "./bookContent.vue?vue&type=style&index=0&id=2eef73ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eef73ae",
  null
  
)

export default component.exports